// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-des {
  font-size: 15px;
  padding: 15px;
}

.des-box {
  margin: 2px 4px;
}

.banner-box {
  padding: 5px;
}

.name-box {
  position: absolute;
  color: #fff;
  z-index: 25;
  bottom: 0;
  width: 100%;
  text-shadow: 1px 1px 3px #000;
  padding: 0 35px;
  /* font-size: 29px; */
  font-size: 7.5vw;
}

@media screen and (min-width: 700px) {
  .name-box {
    font-size: 30px;
  }
}
.intransition {
  opacity: 0;
}

.intransitionShow {
  opacity: 1;
  transition: opacity 2s;
}

.section-header .title {
  font-size: 30px;
  font-weight: bold;
}
.section-header .desc-box {
  font-size: 15px;
}
.section-header .details, .section-header .details div {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.model-box {
  width: 100%;
  background: #fff;
}
.model-box ion-title {
  background: #fff;
  padding: 0 3px;
  font-size: 16px;
}
.model-box .img-box {
  width: 100%;
  max-height: 120px;
  vertical-align: middle;
  display: table;
}
.model-box .img-box app-img {
  vertical-align: middle;
  display: table-cell;
  width: 100%;
}

@media screen and (min-width: 767px) {
  .model-box .img-box {
    width: 100%;
    height: 200px;
    vertical-align: middle;
    display: table;
  }
}
.title-chip {
  margin: 0 5px;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/section/section.page.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,aAAA;AACF;;AAEA;EACE,eAAA;AACF;;AAMA;EACE,YAAA;AAHF;;AAMA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;EACA,WAAA;EACA,6BAAA;EACA,eAAA;EACA,qBAAA;EACA,gBAAA;AAHF;;AAOA;EACE;IACE,eAAA;EAJF;AACF;AAOA;EACE,UAAA;AALF;;AAQA;EACE,UAAA;EACA,sBAAA;AALF;;AAWE;EACE,eAAA;EACA,iBAAA;AARJ;AAWE;EACE,eAAA;AATJ;AAaE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAXJ;;AAmDA;EACE,WAAA;EACA,gBAAA;AAhDF;AAkDE;EACE,gBAAA;EACA,cAAA;EACA,eAAA;AAhDJ;AAmDE;EACE,WAAA;EAEA,iBAAA;EACA,sBAAA;EACA,cAAA;AAlDJ;AAqDE;EACE,sBAAA;EACA,mBAAA;EACA,WAAA;AAnDJ;;AAsDA;EAEI;IACE,WAAA;IACA,aAAA;IAEA,sBAAA;IACA,cAAA;EArDJ;AACF;AA2DA;EACE,aAAA;AAzDF","sourcesContent":[".text-des {\n  font-size: 15px;\n  padding: 15px;\n}\n\n.des-box {\n  margin: 2px 4px;\n}\n\n.itemBack {\n  //background: #e3e1e1;\n}\n\n.banner-box {\n  padding: 5px;\n}\n\n.name-box {\n  position: absolute;\n  color: #fff;\n  z-index: 25;\n  bottom: 0;\n  width: 100%;\n  text-shadow: 1px 1px 3px #000;\n  padding: 0 35px;\n  /* font-size: 29px; */\n  font-size: 7.5vw;\n}\n\n\n@media screen and (min-width: 700px) {\n  .name-box {\n    font-size: 30px;\n  }\n}\n\n.intransition {\n  opacity: 0;\n}\n\n.intransitionShow {\n  opacity: 1;\n  transition: opacity 2s;\n}\n\n\n.section-header {\n\n  .title {\n    font-size: 30px;\n    font-weight: bold;\n  }\n\n  .desc-box {\n    font-size: 15px;\n    //max-height: 70px;\n  }\n\n  .details, .details div {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n  }\n}\n\n//.cartSidePanel {\n//  position: fixed;\n//  z-index: 111;\n//  width: 20%;\n//  top: 0;\n//}\n\n//.sectionSidePanel {\n//  position: fixed;\n//  z-index: 111;\n//  width: 20%;\n//  top: 0;\n//}\n\n//.sectionSideBar {\n//  display: block;\n//  width: 20%;\n//}\n\n//.mainOnSectionSideBar {\n//  display: block;\n//  width: 80%;\n//}\n\n//@media screen and (min-width: 1400px) {\n//  .sectionSideBar {\n//    width: 20%;\n//  }\n//  .sectionSidePanel {\n//    width: 20%;\n//  }\n//  .mainOnSectionSideBar {\n//    width: 60%;\n//  }\n//}\n\n.model-box {\n  width: 100%;\n  background: #fff;\n\n  ion-title {\n    background: #fff;\n    padding: 0 3px;\n    font-size: 16px;\n  }\n\n  .img-box {\n    width: 100%;\n    //height: 120px;\n    max-height: 120px;\n    vertical-align: middle;\n    display: table;\n  }\n\n  .img-box app-img {\n    vertical-align: middle;\n    display: table-cell;\n    width: 100%;\n  }\n}\n@media screen and (min-width: 767px) {\n  .model-box {\n    .img-box {\n      width: 100%;\n      height: 200px;\n      //max-height: 200px;\n      vertical-align: middle;\n      display: table;\n    }\n  }\n\n}\n\n\n.title-chip{\n  margin: 0 5px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
